import { FC, HTMLAttributes } from "react"
import styled from "@emotion/styled"

export const Icon = styled(
  ({ className, ...props }: HTMLAttributes<HTMLDivElement>) => (
    <div className={`c-icon ${className ?? ""}`} {...props} />
  ),
)``
